import React, { useState } from 'react';
import ElectronicHealthCardContactInfoContact from './ElectronicHealthCardContactInfoContact';
import NCZIEditContactModal from '../EditContactModal/NCZIEditContactModal';
import { useNCZIContext } from '../../../../Services/NCZIContext';
import useNCZI from '../../../../Hooks/useNCZI';
// @ts-ignore
import styles from './ElectronicHealthCardInfoContactWrapper.module.scss';

interface Props {
	patientIdentifier: string;
	setLoadingCommandId: (id: string) => void;
	patientName?: string;
}

const ElectronicHealthCardInfoContactWrapper: React.FC<Props> = ({
	patientIdentifier,
	setLoadingCommandId,
	patientName,
}) => {
	const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
	const { patientSummaryContactData } = useNCZIContext();
	const { fetchPatientSummaryContactData } = useNCZI();

	const handleLoadPatientContactData = async () => {
		if (patientIdentifier) {
			const command = await fetchPatientSummaryContactData(patientIdentifier);
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};
	const handleCloseEdit = async (needReload: boolean) => {
		setIsEditOpen(false);
		if (needReload) {
			await handleLoadPatientContactData();
		}
	};

	return (
		<div className={styles.wrapper}>
			<ElectronicHealthCardContactInfoContact
				data={patientSummaryContactData.patientContact}
				patientIdentifier={patientIdentifier}
				handleReloadData={handleLoadPatientContactData}
				handleEdit={() => setIsEditOpen(true)}
				patientName={patientName}
			/>
			<NCZIEditContactModal
				patientIdentifier={patientIdentifier}
				opened={isEditOpen}
				onClose={handleCloseEdit}
				contactInformation={patientSummaryContactData.patientContact}
			/>
		</div>
	);
};

export default ElectronicHealthCardInfoContactWrapper;
